import axios from "axios";

export const request = async (url: string, method: "GET" | "POST" | "PUT" | "DELETE", data?: any, config?: any) => {

    
    try {
        const response = await axios({
            url: `${url}`,
            method,
            data,
            headers: {
                ...config,
            },
        });
        return response.data;
    } catch (error: any) {
        throw error.response ? error.response.data : error;
    }
};